import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../Assets/logo.svg'

function Navbar() {
    return (
        <nav className="navbar navbar-dark navbar-expand-lg fixed-top py-3 navbar-custom" id="mainNav">
            <div className="container px-4 px-lg-5">
                <Link to='/sign-kit/convert' className="navbar-brand mb-0 h1">
                    <img src={logo} height="30" className="d-inline-block align-top me-3" alt="Logo" />
                    Samvaad
                </Link>
                <button className="navbar-toggler navbar-toggler-right" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarResponsive">
                    <ul className="navbar-nav ms-auto my-2 my-lg-0">
                        <li className="nav-item"><Link to='/sign-kit/convert' className="nav-link">Convert</Link></li>
                        <li className="nav-item"><Link to='/sign-kit/learn-sign' className="nav-link">Learn Sign</Link></li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default Navbar